import type { DriverProfileRow, UniformItemRow, UniformRequestRow } from '@routeback/core';
import { useLiveQuery } from 'dexie-react-hooks';
import { useApp } from '../../lib/app';

/** Active catalog items in order (read from the phone, works offline). */
export function useUniformItems(includeInactive = false): UniformItemRow[] {
  const app = useApp();
  return useLiveQuery(
    async () => (await app.db.table<UniformItemRow, string>('uniform_items').where('company_id').equals(app.company.id).toArray())
      .filter((i) => !i.deleted_at && (includeInactive || i.active))
      .sort((a, b) => a.sort_order - b.sort_order || a.name.localeCompare(b.name)),
    [app.db, app.company.id, includeInactive],
    [] as UniformItemRow[],
  );
}

/** Every uniform item I've asked for. */
export function useMyUniformRequests(): UniformRequestRow[] {
  const app = useApp();
  return useLiveQuery(
    async () => (await app.db.table<UniformRequestRow, string>('uniform_requests').where('company_id').equals(app.company.id).toArray())
      .filter((r) => !r.deleted_at && r.user_id === app.userId),
    [app.db, app.company.id, app.userId],
    [] as UniformRequestRow[],
  );
}

/** My profile row in this company (sizes live here), if it exists yet. */
export function useMyProfile(): DriverProfileRow | undefined | null {
  const app = useApp();
  return useLiveQuery(
    async () => (await app.db.table<DriverProfileRow, string>('driver_profiles').where('company_id').equals(app.company.id).toArray())
      .find((p) => !p.deleted_at && p.user_id === app.userId) ?? null,
    [app.db, app.company.id, app.userId],
  );
}
